export const uriToHttps = (uri: string): string | undefined => {
  const protocol = uri.split(":")[0].toLowerCase();
  switch (protocol) {
    case "https":
      return uri;
    case "http":
      return "https" + uri.substr(4), uri;
    case "ipfs":
      const hash = uri.replace("ipfs/", "").match(/^ipfs:(\/\/)?(.*)$/i)?.[2];
      return `https://ipfs.io/ipfs/${hash}/`;
    case "ipns":
      const name = uri.match(/^ipns:(\/\/)?(.*)$/i)?.[2];
      return `https://ipfs.io/ipns/${name}/`;
    default:
      return undefined;
  }
};

export const buildIPFSUri = (cid: string) => `ipfs://ipfs/${cid}`;
